import React from 'react'
import "./VerticalProgBar.css"

function VerticalProgBar({ title, progress, levels }) {
    return (
        <div className="progress-bar-container" style={{ position: "relative" }}>
            <h5 className={`${title === "Difficulty" ? "titlecolorDiff" : "titlecolorSkill"}`}>{title}</h5>
            <div className="d-flex gap-3" style={{ marginRight: "51px" }}>
                <div className="progress-bar" style={{ margin: "0px 10px" }}>
                    <div
                        className="progress"
                        style={{
                            height: `${progress}%`,
                            background: title === "Difficulty" ? "#83cbeb" : "#84e291",
                            borderRadius: "unset"
                        }}
                    ></div>
                </div>
                <div className={`${title === "Difficulty" ? "progress-labels" : "progress-labels-skill"}`}>
                    {levels.map((level, index) => (
                        <span key={index}>{level}</span>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default VerticalProgBar